// tracking (userType)
export const USERTYPE_ANONYMOUS = 'ANON';

// carousel model types
export const MODEL_CHARACTER_CAROUSEL = 'characterCarousel';
export const MODEL_HUB = 'hub';
export const MODEL_PROMOTION = 'promotion';
export const MODEL_SHOW_MOVIE_HYBRID = 'showMovieHybrid';
export const MODEL_TRENDING = 'trending';
export const MODEL_TOP_SHOWS = 'topShows';
export const MODEL_TOP_STORIES = 'topStories';
export const MODEL_MULTICHANNEL = 'multiChannel';
export const MODEL_CHANNEL = 'channel';
export const MODEL_VIDEO = 'video';
export const MODEL_VIDEOCONFIG = 'videoConfig';
export const MODEL_PROMINENT_CAROUSEL = 'prominentCarousel';

export const AGE_GATE_STATUS_COOKIE = 'ageGateStatus';
export const AGE_GATE_STATUS = {
    UNVERIFIED: 'unverified',
    VALID: 'valid',
    INVALID: 'invalid',
};
